import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
/* global getURLParam getURLParams Uri */
import { getPage, getIndex } from '../common/requestUtils.js';

import { Tabs } from '../common/Tabs.js';
import '../common/pagination.js';
import { makeSearchURL, convertToApiURL } from '../common/searchRequestUtils.js';

import useTabs from '../common/tabs/useTabs.js';
import useConstructor from '../common/react/useConstructor.js';
import useGiveWidget from '../common/giveWidget/useGiveWidget.js';
import TabContents from './TabContents.js';

import { Immutable } from '../../external/immutable.js';


const DEFAULT_PER_PAGE_RESULTS = 10;
const DEFAULT_SEARCH_URL = baseURL + 'donors/search.html';

export const getSearchApiURL = function (districtId, historical) {
    const max = DEFAULT_PER_PAGE_RESULTS;
    const index = getIndex(location.href, max);
    const searchUrlParams = {
        community: districtId + '%3A2',
        includeNearbyLocations: false,
        historical: historical,
        index: index || 0,
        max: max,
    };
    const searchUrl = makeSearchURL(searchUrlParams, DEFAULT_SEARCH_URL, null);
    const apiUrl = convertToApiURL(searchUrl, DEFAULT_PER_PAGE_RESULTS, max);
    return apiUrl;
};

let DistrictPartnerTabsController = function (props) {
    const [showGiveWidget, toggleGiveWidget] = useGiveWidget();
    const districtId = props.districtId;
    const funded = props.funded;
    const active = props.active;

    const getTabName = function (url) {
        const params = getURLParams(url);
        if (params.active) return 'ACTIVE';
        if (params.historical) return 'HISTORICAL';
    };

    const validTabs = React.useMemo(() => {
        return Immutable.OrderedMap().withMutations(function (map) {
            if (active > 0) {
                map.set('ACTIVE', Immutable.Map({
                    name: 'ACTIVE',
                    label: 'Project requests',
                    count: active,
                    paramName: 'active',
                    fundingStatus: 'needs funding',
                    indexParam: 'index',
                    requestURL: getSearchApiURL(districtId, false),
                }));
            }
            if (funded > 0) {
                map.set('HISTORICAL', Immutable.Map({
                    name: 'HISTORICAL',
                    label: 'Funded projects',
                    count: funded,
                    paramName: 'historical',
                    fundingStatus: 'funded',
                    indexParam: 'index',
                    requestURL: getSearchApiURL(districtId, true),
                }));
            }
        });
    });

    const convertToApiURL = React.useCallback(function (pageUrl, tab) {
        const maxParam = tab.get('maxParam');
        const perPage = DEFAULT_PER_PAGE_RESULTS;
        const index = getIndex(pageUrl, perPage);
        const apiUri = new Uri(tab.get('requestURL'));

        const verifyShowPhotos = getURLParam(pageUrl, 'verifyShowPhotos');
        if (verifyShowPhotos) {
            apiUri.add('verifyShowPhotos', verifyShowPhotos);
        }

        if (maxParam) {
            apiUri.replace(maxParam, perPage);
        }
        apiUri.replace(tab.get('indexParam'), index);

        return apiUri.toString();
    });

    const makeDataPromise = React.useCallback(function (pageUrl, tab) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: convertToApiURL(pageUrl, tab),
                cache: true,
                dataType: 'json',
                success: (data) => {
                    resolve(data);
                },
                error: () => {
                    reject('There was a problem loading more results. Please try again later.');
                },
            });
        });
    }, [convertToApiURL]);

    const updateActiveCount = React.useCallback(function (newData, tab) {
        console.log(tab);
        tab.set('count', newData.totalProposals);
        console.log(tab);
        console.log(newData);
    });

    const { activateTab, changeURL, closeTab, activeTabName, loading, data, url, isMobile } = useTabs(
        makeDataPromise, validTabs, getTabName, updateActiveCount,
    );

    useConstructor(function () {
        // The tab specified in the URL takes priority
        const paramTab = getTabName(location.href);
        if (paramTab && validTabs.has(paramTab)) {
            changeURL(location.href);
        }

        if (validTabs.isEmpty()) {
            return;
        }

        const tabName = getTabName(url);
        activateTab(
            validTabs.has(tabName)
                ? tabName
                : validTabs.keySeq().first(),
        );
    });

    return (
        <div className="col col9 tabs-wrapper">
            <Tabs validTabs={validTabs} isMobileDropdownStyle={true} isMobile={isMobile} activeTabName={activeTabName}
                activateTab={activateTab} closeTab={closeTab}/>
            <TabContents loading={loading} isMobile={isMobile} url={url} activeTabName={activeTabName} page={getPage(url)}
                data={data} validTabs={validTabs} perPage={DEFAULT_PER_PAGE_RESULTS} activateTab={activateTab}
                changeURL={changeURL} closeTab={closeTab} showGiveWidget={showGiveWidget} toggleGiveWidget={toggleGiveWidget}/>
        </div>
    );
};

DistrictPartnerTabsController.propTypes = {
    districtId: PropTypes.string.isRequired,
    funded: PropTypes.number,
    active: PropTypes.number,
};

DistrictPartnerTabsController = React.memo(DistrictPartnerTabsController);
export default DistrictPartnerTabsController;
